import { Outlet } from 'react-router-dom';

export default function Companies() {
  return (
    <>
      <Outlet />
    </>
  );
}
